export const style = {
  avilabilityTopContainer: {
    padding: "2rem 2.4rem",
    background: "var(--blue-gray-100)",
    textAlign: "left",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "sticky",
    top: "0rem",
    zIndex: 100,
  },
  avilabilityTopContainerText: {
    display: "flex",
    alignItems: "center",
    "& > h4": {
      color: "var(--black-900)",
      fontSize: "2.4rem",
      fontWeight: 500,
    },
  },
  hospitalsList: {
    width: "30%",
    bgcolor: "var(--neutral-100)",
    borderRight: "0.1rem solid var(--gray-200)",
  },
  teamList: {
    width: "35%",
    maxHeight: "40rem",
    overflowY: "auto",
    bgcolor: "var(--neutral-100)",
    borderRight: "0.1rem solid var(--gray-200)",
  },
  teamDetail: {
    width: "35%",
  },
  innerContainer: {
    display: "flex",
    width: "100%",
  },
};
